// Trong utils/scroll-utils.ts
export const scrollToElement = (
  selector: string,
  options: ScrollIntoViewOptions = {}
) => {
  const element = document.querySelector(selector)
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
      ...options,
    })
  }
}

// Cuộn tới selector với offset (px) và delay (ms)
export const scrollToElementWithOffset = (
  selector: string,
  offset = 0,
  delay = 0
) => {
  setTimeout(() => {
    const el = document.querySelector(selector) as HTMLElement | null
    if (!el) return
    const top = el.getBoundingClientRect().top + window.scrollY - offset
    window.scrollTo({ top, behavior: 'smooth' })
  }, delay)
}

export const scrollToProductSection = (offset = 200, delay = 50) => {
  scrollToElementWithOffset('#collection-listing', offset, delay)
}
